<template lang="pug">
  .box.youtube-modal
    h3.title(
      v-if="!selected"
    )
      | YouTube video for the word: "
      b {{ lemma }}
      | "
    article.message.is-light(
    v-if="!selected"
    )
      .message-body
        | Enter the name of a song or the title of a movie

    h3.title(
      v-if="selected"
    )
      | Sentence for the word: "
      b {{ lemma }}
      | "

    article.message.is-light(
    v-if="selected"
    )
      .message-body
        | Drag the blue slider extremities to define where the sentence is said.

    transition(name="slide" mode="out-in")
      b-field(
        v-if="!selected"
      )
        b-input.is-wide#search_youtube(
        v-model="query"
        icon="search"
        size="is-medium"
        placeholder="Movie scene or song's title"
        autocomplete="off"
        @keyup.native.enter="queryYoutubeApi()"
        )
        p.control.has-text-centered
          button.button.is-primary.mw-110px.is-medium.has-flex-center-items.has-text-centered(
          @click="queryYoutubeApi"
          :class=`{
            'is-loading': loading,
          }`
          :disabled="loading || !query.length"
          )
            b-icon(v-if="loadingSuccess" icon="check")
            span(v-else="")
              | Search
    transition(name="slide" mode="out-in")
      .result-wrapper(v-if="!selected && items.length")
        .columns.is-multiline
          .column.is-3(v-for="item in items")
            .card.is-clickable(@click="chooseVideo(item)")
              .card-image
                figure.image
                  img(
                  :src="item.snippet.thumbnails.medium.url"
                  :width="item.snippet.thumbnails.medium.width"
                  :height="item.snippet.thumbnails.medium.height"
                  )
              p.video--title.pt-2.px-2 {{ item.snippet.title }}
              p.video--channel.px-2.pb-2 {{ item.snippet.channelTitle }}
              p.video--views-count.px-2.pb-2 {{ displayViewCount(viewsCount[item.id.videoId]) }}

    .pick-time-range(v-show="selected && items.length")
      .columns.is-multiline
        .column(:class="{'is-8 pr-0': transcripts.length, 'is-12': !transcripts.length}")
          .time-picker
            .current-time(v-show="currentTime")
              | {{ parseInt(currentTime/60) || '00' }}:{{ (currentTime%60) ? ((currentTime%60 < 10) ? "0"+currentTime%60 : currentTime%60) : '00' }}
            .card-image
              youtube(
                @click="playVideoAndUpdateValue"
                :video-id="selected ? selected.id.videoId : null"
                :player-vars="playerVars"
                ref="youtube"
                @paused="pausedVideo"
                @playing="playingVideo")
              <!--figure.image-->
                <!--img(-->
                <!--:src="selected.snippet.thumbnails.high.url"-->
                <!--:width="selected.snippet.thumbnails.high.width"-->
                <!--:height="selected.snippet.thumbnails.high.height"-->
                <!--)-->
          transition(name="fade" mode="out-in")
            .range-slider.pt-4.pl-3.pr-2(v-if="selected && selected.duration")
              vue-slider.mt-3(
                v-model="sliderValue"
                :interval="1"
                :slider-style="sliderStyle"
                :fixed="false"
                :tooltip-merge="false"
                :piecewise-label="true"
                tooltip="always"
                :tooltipStyle="tooltipStyle"
                :processStyle="processStyle"
                :processDragable="true"
                :min="sliderMin"
                :max="sliderMax"
                )
                template(slot="tooltip" slot-scope="tooltip")
                  span.custom-tooltip
                    | {{ parseInt(tooltip.value/60) || '00' }}:{{ (tooltip.value%60) ? ((tooltip.value%60 < 10) ? "0"+tooltip.value%60 : tooltip.value%60) : '00' }}
                template(slot="label" slot-scope="{ label, active }")
                  span(:class="['custom-label', { active }]" v-if="(isZoomed && label % 2 === 0) || label % 30 === 0")
                    | {{ parseInt(label/60) }}:{{ (label%60) ? ((label%60 < 10) ? "0"+label%60 : label%60) : '00' }}
              .field.mt-3.has-addons
                button.button.is-medium.is-dark.mr-1(@click="setSliderSec(sliderValue[0] - 0.5, sliderValue[1])") -½s
                button.button.is-medium.is-dark.mr-1(@click="setSliderSec(sliderValue[0] + 0.5, sliderValue[1])") +½s
                button.button.is-medium.is-dark.is-wide.mr-1(@click="playRange()")
                  transition(name="fade" mode="out-in")
                    b-icon(icon="replay" v-if="playing" key="1")
                    b-icon(icon="play-arrow" v-else key="2")
                button.button.is-medium.is-dark.mr-1(@click="sliderSecExtend(sliderValue[1] - 0.5)") -½s
                button.button.is-medium.is-dark.mr-1(@click="sliderSecExtend(sliderValue[1] + 0.5)") +½s
                button.button.is-medium.is-dark.mr-1(@click="setSliderSec(sliderValue[0], sliderValue[0] + 3);zoomIn()") 3s
                button.button.is-medium.is-dark(@click="toggleZoom()" :disabled="!isZoomed && (max-min) > 15")
                  b-icon(:icon="isZoomed ? 'zoom-out' : 'zoom-in'")

              <!--input.slider.is-fullwidth(-->
                <!--step="2"-->
                <!--min="0"-->
                <!--max="100"-->
                <!--value="50"-->
                <!--type="range"-->
                <!--)-->

        transition(name="fade" mode="out-in")
          .column.is-4.pl-0(v-if="selected && transcripts.length")
            .subtitles-wrapper.px-2.py-1
              button.button.is-fullwidth.has-justified-start.mb-1(
              @click="goToSubtitle(item)"
              v-for="item in transcripts"
              v-html="item.txt"
              :class="{'is-dark': !item.txt.match(match), 'is-dark has-text-weight-bold': item.txt.match(match)}")

        .column.is-12(v-if="selected")
          .is-flex
            b-field.is-wide(label="Video")
              b-input(v-model="selected.snippet.title" disabled icon="videocam")
            b-field.mx-2(label="Starts at")
              .control.has-icons-left.is-clearfix
                input.input(:value="startsAtHuman" disabled)
                span.icon.is-left
                  i.mdi.mdi-access-time
            b-field(label="Ends at")
              .control.has-icons-left.is-clearfix
                input.input(:value="endsAtHuman" disabled)
                span.icon.is-left
                  i.mdi.mdi-access-time
          .is-flex.has-flex-start-items.has-flex-wrap
            b-field.has-addons.has-flex-wrap.is-wide(:type="success ? 'is-success' : ''")
              label.label.w-100 Sentence
              b-input.is-wide(
                v-model="sentence"
                placeholder="Type the sentence we hear in the video clip"
                icon="short-text")
              p.mt-2.w-100(v-if="category == 'music'")
                a.button.is-small.is-info.is-outlined(:href="googleQuery" target="_blank")
                  | Search for the lyrics

            b-field.has-addons.has-flex-wrap.ml-2.ml-0-mobile
              label.label.w-100 Word
              b-input.is-wide(
                @click.native="editingWord = true"
                @focus="editingWord = true"
                v-if="!editingWord"
                v-model="updatedLemma"
                placeholder="Word"
                icon="short-text"
              )
              word-select.ml-0-mobile(
                v-else
                v-model="updatedLemma"
                :prefill="updatedLemma"
                @hit="hit"
                @finished="editingWord = false"
              )
            b-field.ml-2.category-selector(label="Category")
              .w-100
                b-radio(
                  v-model="category"
                  v-for="option in categories"
                  :native-value="option.id"
                  :key="option.id"
                )
                  b-tooltip(
                  :animated="true" :label="option.value" type="is-dark" position="is-top")
                    b-icon(:icon="option.icon" :type="category == option.id ? 'is-dark' : 'is-grey'")

              <!--b-select(placeholder="Select" v-model="category")-->
                <!--option(v-for="option in categories" :value="option.id" :key="option.id")-->
                  <!--| {{ option.value }}-->




    .actions.pt-3.is-flex
      button.button(v-if="selected" @click="reset()")
        | Back
      button.button.ml-auto.mw-70px(
        :disabled="!sentence.length || !category"
        @click="save"
        :class=`{
          'is-primary': sentence.length,
          'is-loading': saving,
          'is-success': success
          }`
        )
        b-icon(v-if="success" icon="check")
        span(v-if="!success && !model")
          | Add
        span(v-if="!success && model")
          | Save

</template>

<script>
  import {Youtube, Sentence} from '@/store/models/resources';
  import {nodeApi} from "@/config";
  import _ from "lodash";
  import {mapGetters} from 'vuex'
  import wordSelect from '@/components/WordSelect';
  import vueSlider from 'vue-slider-component';

  // https://nightcatsama.github.io/vue-slider-component/example/

  export default {
    name: "YoutubeModal",
    components: {
      vueSlider,
      wordSelect
    },
    props: [
      'lemma',
      'pos',
      'model'
    ],
    computed: {
      ...mapGetters(['display', 'filters', 'uuid']),
      googleQuery() {
        const query = encodeURI(`${this.selected.snippet.title.replace(/\(.*\)/ig, '')}`);
        // return `https://www.google.com/search?btnI=1&q=${query}`
        // return `https://duckduckgo.com/?q=!ducky+${query}`
        return `https://search.azlyrics.com/search.php?q=${query}`
      },
      player() {
        return this.$refs.youtube.player
      },
      min() {
        const [a, b] = this.sliderValue;
        return a
      },
      max() {
        const [a, b] = this.sliderValue;
        return b
      },
      startsAtHuman() {
        return `${parseInt(this.min/60)}:${ (this.min%60) ? ((this.min%60 < 10) ? "0"+this.min%60 :  this.min%60) : '00' }`
      },
      endsAtHuman() {
        return `${parseInt(this.max/60)}:${ (this.max%60) ?  ((this.max%60 < 10) ? "0"+this.max%60 :  this.max%60) : '00' }`
      },
      isZoomed() {
        return this.sliderMin != 0 || this.sliderMax != this.prevMax
      },
      // currentTime() {
      //   if (!this.player) {
      //     return 0
      //   } else {
      //     console.log('time is ', this.$refs.youtube.player.getCurrentTime());
      //     return this.$refs.youtube.player.getCurrentTime()
      //   }
      // }
    },
    watch: {
      sliderValue(newVal, oldVal) {
        // Moved left slider for first time
        // if (oldVal[0] == 0 && newVal[0] != 0 && newVal[1] == this.sliderMax && this.sliderMax) {
        //   // We zoom in
        //   this.sliderMin = _.max([newVal[0] - 10, 0]);
        //   this.sliderMax = _.min([newVal[0] + 10, this.prevMax]);
        //   newVal[1] = this.newVal[0] + 5
        // }

        // We extended right slider
        console.log({newVal, oldVal, test: newVal[0] == oldVal[0]});
        console.log('extended :: ', newVal[1] > oldVal[1] && newVal[0] == oldVal[0] && newVal[1] != this.sliderMax && this.sliderMax)
        if (newVal[1] > oldVal[1] && newVal[0] == oldVal[0] && newVal[1] != this.sliderMax && this.sliderMax) {
          console.log('PLAYING from ', oldVal[1], ' to ', newVal[1]);
          this.playCustomRange(oldVal[1], newVal[1])
        } else if (newVal[0] != 0) {
          this.playRange();
        }
      }
    },
    data() {
      return {
        isSuccess: false,
        posOpts:  {
          fw: 'function word',
          v: 'verb',
          r: 'adverb',
          n: 'noun',
          j: 'adjective',
          u: 'interjection',
          m: 'number',
          K: 'proper noun',
          abbr: 'abbreviation',
        },
        categories: [
          {id: 'music', value: 'Music & Lyrics', icon: 'music-video'},
          {id: 'movie', value: 'Movie scene', icon: 'movie'},
          {id: 'tv_show', value: 'TV show', icon: 'tv'},
          {id: 'other', value: 'Other', icon: 'videocam'},
        ],
        category: null,
        saving: false,
        success: false,
        currentTime: 0,
        currentTimeListener: null,
        sentence: "",
        updatedLemma: '',
        for_word: '',
        for_lemma_pos: '',
        // WORD SELECT
        editingWord: false,
        // SLIDER
        sliderValue: [0, 0],
        sliderFixed: true,
        sliderMin: 0,
        sliderMax: null,
        prevMax: 0,
        sliderStyle: [
          {
            "backgroundColor": "#83ABEC"
          },
          {
            "backgroundColor": "#6887ba"
          }
        ],
        tooltipStyle: [
          {
            "backgroundColor": "#164591",
            "borderColor": "#164591"
          },
          {
            "backgroundColor": "#184C9F",
            "borderColor": "#184C9F"
          }
        ],
        processStyle: {
          "backgroundImage": "-webkit-linear-gradient(left, #83ABEC, #6887ba)"
        },
        // YOUTUBE QUERY
        loading: false,
        loadingSuccess: false,
        query: "",
        items: [],
        viewsCount: {},
        captions: [],
        transcripts: [],
        selected: null,
        match: null,
        // YOUTUBE IFRAME PLAYER
        playerVars: {
          showinfo: 0,
          autoplay: 1,
          rel: 0,
          controls: 0,
          cc_load_policy: 1,
          iv_load_policy: 3,
          color: 'white'
        },
        playing: false,
        pausesQueue: [],
      };
    },
    beforeDestroy() {
      document.removeEventListener('keyup', this.onSpaceHit);
      this.stopCurrentTimeListener()
    },
    mounted() {
      if (!this.model) {
        setTimeout(() => {
          document.getElementById('search_youtube').focus()
        }, 300);
      }

      this.match = RegExp(`(?:^|\\W)(${this.lemma})(?:$|\\W)`, 'ig')

      // pos[word.pos]

      this.updatedLemma =`${this.lemma} (${this.posOpts[this.pos]})`
      this.for_lemma_pos = `${this.lemma}|${this.pos}`
      document.addEventListener('keyup', this.onSpaceHit);
      this.startCurrentTimeListener();

      if (this.model) {
        this.sentence = this.model.content;
        this.items = [{}];
        // this.updatedLemma = this.model.for_word;
        // `${this.lemma} (${this.posOpts[this.pos]})`
        // this.sliderValue = [this.model.starts_at, this.model.ends_at];
        this.chooseVideo({
          id: {
            videoId: this.model.youtube_uid
          },
          snippet: {
            title: ''
          }
        })
      }

    },
    methods: {
      startCurrentTimeListener() {
        this.currentTimeListener = setInterval(() => {
          if (this.player) {
            // console.log('new time is ',  this.player.getCurrentTime());
             this.player.getCurrentTime().then(time => {
               this.currentTime = parseInt(time)
             })
          }
        }, 400);
      },
      stopCurrentTimeListener() {
        if (this.currentTimeListener) {
          clearInterval(this.currentTimeListener);
        }
      },
      zoomIn() {
        this.sliderMin = _.max([this.min - 10, 0]);
        this.sliderMax = _.min([this.max + 10, this.prevMax]);
      },
      toggleZoom() {
        if (this.isZoomed) {
          this.sliderMin = 0;
          this.sliderMax = this.prevMax;
        } else {
          this.sliderMin = _.max([this.min - 10, 0]);
          this.sliderMax = _.min([this.max + 10, this.prevMax]);
        }
      },
      reset() {
        this.selected = null;
        // this.items = [];
        this.captions = [];
        this.transcripts = [];
        this.sliderValue = [0, 8];
        this.sliderMax = null;
        this.sliderMin = 0;
        this.prevMax = 0;
        setTimeout(() => {
          document.getElementById('search_youtube').focus()
        }, 200)
      },
      goToSubtitle(sub){
        this.sentence = sub.txt.replace(/(&quot;|<em>|♪)/g, '').replace(/&#39;/g, "'").replace(/(<br>|<\/em>)/g, " ").replace(/ +/, " ");
        this.sliderValue = [parseInt(sub.st), Math.ceil(sub.en)];
        this.playRange()
      },
      goToSec: _.throttle(function() {
        console.log('THROTTLE');
        let tm;
        this.player.seekTo(this.min, true)
        if (!this.playing) {
          this.player.playVideo();
        }
        console.log('playing for: ', this.max-this.min, 's')
        while (tm = this.pausesQueue.shift()) {
          clearTimeout(tm);
        }
        this.pausesQueue.push(setTimeout(() => {
          this.player.pauseVideo();
        }, (this.max-this.min)*1000))
      }, 400),
      playCustomRange(min, max) {
        let tm;
        this.player.seekTo(min, true)
        while (tm = this.pausesQueue.shift()) {
          clearTimeout(tm);
        }
        if (!this.playing) {
          this.player.playVideo();
        }
        this.pausesQueue.push(setTimeout(() => {
          this.player.pauseVideo();
        }, (max-min)*1000))
      },
      playRange() {
        let tm;
        this.player.seekTo(this.min, true)
        while (tm = this.pausesQueue.shift()) {
          clearTimeout(tm);
        }
        if (!this.playing) {
          this.player.playVideo();
        }
        this.pausesQueue.push(setTimeout(() => {
          this.player.pauseVideo();
        }, (this.max-this.min)*1000))
      },
      sliderSecExtend(b) {
        this.$set(this.sliderValue, 1, b);
        setTimeout(() => {
          this.playCustomRange(b-1, b);
        }, 300)
      },
      setSliderSec(a, b){
        // let [oldStart, oldEnd] = this.sliderValue;
        this.sliderValue = [a, b];

        // if (playEndOnly) {
        //   // this.playCustomRange(b-2, b)
        // } else {
        //   this.playRange();
        // }
      },
      queryYoutubeApi() {
        if (this.query.length) {
          this.loading = true;
          this.reset();

          // snippet => title, channel, thumbnail
          // contentDetails => duration

          const opts = {
            q: this.query,
            part: 'snippet',
            type: 'video',
            hl: 'en',
            videoEmbeddable: 'true',
            // videoCaption: 'closedCaption',
            maxResults: 25
          };

          try {
          const request = window.gapi.client.youtube.search.list(opts);
          console.log('request is ', request)

          request.execute((response) => {
            console.log({response});
            this.loading = false;
            if (response.result && response.result.items) {
              this.loadingSuccess = true;
              // console.log('response is ', response.result.items)
              this.items = response.result.items;
              this.queryViewsCount();
              setTimeout(() => {
                this.loadingSuccess = false;
              }, 2500)
            } else {
              this.$toast.open({
                duration: 5000,
                message: 'Youtube service can\'t be reached. Please reload the page and retry',
                type: "is-danger"
              });
            }
          });
          } catch(e) {
            window.location.reload();
          }
        }
      },
      displayViewCount(nb) {
        if (!nb) {
          return ''
        }

        if (nb / 1000000000 >= 1) {
          return `${Math.floor(nb / 1000000000)}B`
        }
        if (nb / 1000000 >= 1) {
          return `${Math.floor(nb / 1000000)}M`
        }
        if (nb / 1000 >= 1) {
          return `${Math.floor(nb / 1000)}K`
        }
        return nb;
      },
      queryViewsCount() {
        const opts = {
          id: this.items.map(item => item.id.videoId).join(','),
          part: 'statistics',
        };

        const request = window.gapi.client.youtube.videos.list(opts);
        request.execute((response) => {
          _.each(response.result.items, item => {
            this.viewsCount[item.id] = item.statistics.viewCount
          })
        })
      },
      queryVideoDetails(callback) {
        const {videoId} = this.selected.id;
        const opts = {
          id: videoId,
          part: 'contentDetails',
        };

        const request = window.gapi.client.youtube.videos.list(opts);

        request.execute((response) => {
          console.log('queryVideoDetails:');
          if (response.result) {
            this.selected.durationStr = response.result.items[0].contentDetails.duration
            this.selected.duration = parseInt(this.selected.durationStr.match(/\d+S/))
            if (this.selected.durationStr.match(/\d+M/)) {
              this.selected.duration += parseInt(this.selected.durationStr.match(/\d+M/))*60
            }
            this.prevMax = this.selected.duration;
            this.sliderMax = this.selected.duration;
            if (this.model) {
              this.sliderValue = [this.model.starts_at, this.model.ends_at];
            } else {
              this.sliderValue[1] = this.sliderMax
            }
          }
          // console.log(response);
        });
      },
      chooseVideo(item) {
        // https://stackoverflow.com/questions/14061195/how-to-get-transcript-in-youtube-api-v3

        this.selected = item;
        console.log(this.selected);
        this.queryCaptions();
        this.queryVideoDetails();
        this.ensureWeGetDuration();
      },
      ensureWeGetDuration() {
        setTimeout(() => {
          if (!this.selected.duration) {
            this.queryVideoDetails()
          }
        })
      },
      playVideoAndUpdateValue() {
        if (!this.playing) {
          this.player.playVideo()
        } else {
          this.player.pauseVideo()
        }
      },
      playingVideo() {
        this.playing = true;
        console.log('Video is playing..')
        // console.log('time is ', this.player.getCurrentTime());
        this.player.setVolume(100);
        this.player.getCurrentTime().then((time) => {
          console.log('time is: ', time)
          // const [a, b] = this.sliderValue;
          // this.sliderValue = [Math.round(time*100)/100, Math.round(time*100)/100 + (b-a)]
        })
      },
      pausedVideo() {
        this.playing = false;
        console.log('Video paused..');
      },
      queryCaptions() {
        const {videoId} = this.selected.id;

        const opts = {
          part: 'snippet',
          videoId
        };

        const request = window.gapi.client.youtube.captions.list(opts);

        request.execute((response) => {
          const captions = _.filter(response.result.items, item => item.snippet.language.match(/^en/));
          this.$set(this.selected, 'captions', captions);

          if (captions.length) {

            Youtube.subtitles({id: videoId, lemma: this.lemma}).then((res) => {
              console.log(res);
              this.transcripts = res.body;
            })

            // const captionDetailsOpts = {
            //   id: captions[0].id,
            //   tfmt: 'srt'
            // }
            // const requestDetail = window.gapi.client.youtube.captions.download(captionDetailsOpts);
            // requestDetail.execute((res) => {
            //   console.log('CAPTION DETAILS');
            //   console.log(res)
            // });


            // const transcriptsUrl = `http://video.google.com/timedtext?lang=en&v=${this.selected.id.videoId}`;
            //
            // console.log(transcriptsUrl);
            // this.$http.get(transcriptsUrl, {
            //   headers: {
            //     'Access-Control-Request-Headers': null,
            //     'Authorization': null
            //   }
            // }).then((res) => {
            //   console.log(res);
            // })
          }
        });
      },
      hit(selection) {
        this.for_lemma_pos = selection.value;
        this.for_word = selection.real_word;
      },
      save() {
        const [starts_at, ends_at] = this.sliderValue;
        this.saving = true;
        this.$store.dispatch('saveSentence', {
              id: (this.model || {}).id,
              category: this.category,
              for_lemma_pos: this.for_lemma_pos,
              for_word: this.for_word,
              content: this.sentence,
              youtube_uid: this.selected.id.videoId,
              user_uuid: this.uuid,
              starts_at,
              ends_at
          }
        ).then( (res) => {
            this.saving = false;
            // this.sentence = '';
            this.category = null;
            this.updatedLemma = '';
            this.success = true;
            setTimeout( () => {
              this.success = false;
              if (this.model) {
                this.$emit('close')
              }
            }, 7000)
        })
      },
      onSpaceHit(event) {
        if (event.keyCode == 32 && event.target.className != 'input') {
            event.preventDefault();
            if (this.$refs.youtube && this.$refs.youtube.player) {
              // player.getPlayerState():Number
              //   -1 – unstarted
              // 0 – ended
              // 1 – playing
              // 2 – paused
              // 3 – buffering
              // 5 – video cued
              this.player.getPlayerState().then(state => {
                console.log({ state });
                if (state == 1) {
                  this.playing = false;
                  this.player.pauseVideo()
                } else {
                  this.playing = true;
                  this.player.playVideo()
                }
              });
            }
        }
      }
    },
  };
</script>

<style lang="scss">
  @import "colors";
  $matchYellow: #ffdd57;

  .youtube-modal.box {
    width: 100%;
    margin: auto;

    iframe {
      width: 100%;
    }

    .result-wrapper {
      height: 700px;
      overflow: auto;
    }

    .subtitles-wrapper {
      background-color: $darkGray;
      color: $white;
      height: 512px;
      overflow: auto;
    }

    em {
      font-style: normal;
      margin: 0 3px 0 1px;
      padding: 0 2px 0 1px;
      color: $primaryLight;
      font-weight: 700;
    }

    .subtitles-wrapper .button {
      height: auto;
      display: block;
      text-align: left;
    }
    .is-faded {
      opacity: 0.8;
      transition: opacity .1s ease-in-out;
      &:hover {
        opacity: 1;
      }
    }

    .card {
      transition: all .15s ease-in-out;
      border: 1px solid rgba(97, 97, 229, .1);
      border-radius: 5px;
      -webkit-box-shadow: 0 5px 10px -2px rgba(0, 0, 0, .045);
      box-shadow: 0 5px 10px -2px rgba(0, 0, 0, .045);
      img {
        border-radius: 5px 5px 0 0;
      }
    }
    .range-slider {
      background-color: $darkGray;
      color: $white;
      margin-top: -5px;
      padding-bottom: 14px;
    }
    .time-picker {
      background-color: $darkGray;
      border-right: 0 none;
      position: relative;
    }
    .card:not(.time-picker) {
      &:hover {
        -webkit-box-shadow: 0 5px 23px -5px rgba(0, 0, 0, .175);
        box-shadow: 0 5px 23px -5px rgba(0, 0, 0, .175);
        border: 1px solid rgba(97, 97, 229, .1);
        -webkit-transform: scale(1.01);
        -ms-transform: scale(1.01);
        transform: scale(1.01);
      }
    }

    .current-time {
      position: absolute;
      bottom: 10px;
      color: rgba(214, 214, 214, 0.7411764705882353);
      font-weight: 700;
      z-index: 100;
      padding: 2px 6px;
      left: 10px;
      font-size: 54px;
    }

    .category-selector {
      .control-label {
        align-items: center;
        justify-content: center;
        display: inline-flex;
        margin-right: 0.5rem;
      }
    }

    p.video--title,
    p.video--channel {
      font-family: Montserrat;
    }
    p.video--title {
      font-weight: 700;
      font-size: 0.8rem;
      height: 47px;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      line-height: 13px;
    }
    p.video--channel {
      font-weight: 300;
      font-size: 0.7rem;
    }
    p.video--views-count {
      font-weight: 300;
      font-size: 0.7rem;
      position: absolute;
      right: 0px;
      bottom: 0px;
    }

    .custom-label.active::after {
      background-color: $primaryLight;
      width: 2px;
    }

    .vue-slider-piecewise {
      position: absolute;
      width: 100%;
      padding: 0;
      margin: 0;
      left: 0;
      top: 0;
      height: 100%;
      list-style: none;
    }

    .vue-slider-piecewise-item {
      position: absolute;
      width: 8px;
      height: 8px;
    }

    .custom-label.active {
      color: $primaryLight;
      font-weight: bold;
    }

    .custom-tooltip {
      display: block;
      font-size: 14px;
      white-space: nowrap;
      padding: 2px 5px;
      min-width: 20px;
      text-align: center;
      color: #fff;
      border-radius: 5px;
      border: 1px solid $primaryLight;
      z-index: 1000;
      background-color: $primaryLight;
      font-weight: 700;
      &:before {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 50%;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border: 6px solid transparent\0;
        border-top-color: inherit;
        -webkit-transform: translate(-50%);
        transform: translate(-50%);
      }
    }

    .custom-label {
      position: absolute;
      top: 100%;
      left: 0;
      -webkit-transform: translate(-50%, -3px);
      transform: translate(-50%, 3px);
      margin-left: 3px;
    }

    .vue-slider-component.vue-slider-has-label {
      margin-bottom: 30px;
    }

    .custom-label::after {
      content: '';
      position: absolute;
      bottom: 104%;
      left: 50%;
      -webkit-transform: translate(-50%, 5px);
      transform: translate(-50%, 5px);
      width: 1px;
      height: 5px;
      background-color: #FFF;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/YoutubeModal.vue